import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useEffect } from "react";
import debounce from "lodash/debounce";
import { useField } from "react-final-form";
import { RadioInput } from "@vk-hr-tek/ui/input";
import { compose } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function RadioInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else RadioInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const RadioInput_RadioInput = (t0)=>{
    const $ = c(59);
    let autoSetDefault;
    let debounceTimeout;
    let defaultValue;
    let disabled;
    let label;
    let labelIcon;
    let labelPlacement;
    let name;
    let onChange;
    let options;
    let required;
    let rest;
    let row;
    let t1;
    let t2;
    let testId;
    let tooltip;
    let validate;
    if ($[0] !== t0) {
        ({ label, labelIcon, tooltip, name, onChange, options, defaultValue, autoSetDefault, required, disabled, row, withoutMargins: t1, validate, debounceTimeout, labelPlacement, testId, showError: t2 } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "tooltip",
            "name",
            "onChange",
            "options",
            "defaultValue",
            "autoSetDefault",
            "required",
            "disabled",
            "row",
            "withoutMargins",
            "validate",
            "debounceTimeout",
            "labelPlacement",
            "testId",
            "showError"
        ]);
        $[0] = t0;
        $[1] = autoSetDefault;
        $[2] = debounceTimeout;
        $[3] = defaultValue;
        $[4] = disabled;
        $[5] = label;
        $[6] = labelIcon;
        $[7] = labelPlacement;
        $[8] = name;
        $[9] = onChange;
        $[10] = options;
        $[11] = required;
        $[12] = rest;
        $[13] = row;
        $[14] = t1;
        $[15] = t2;
        $[16] = testId;
        $[17] = tooltip;
        $[18] = validate;
    } else {
        autoSetDefault = $[1];
        debounceTimeout = $[2];
        defaultValue = $[3];
        disabled = $[4];
        label = $[5];
        labelIcon = $[6];
        labelPlacement = $[7];
        name = $[8];
        onChange = $[9];
        options = $[10];
        required = $[11];
        rest = $[12];
        row = $[13];
        t1 = $[14];
        t2 = $[15];
        testId = $[16];
        tooltip = $[17];
        validate = $[18];
    }
    const withoutMargins = void 0 === t1 ? false : t1;
    const showError = void 0 === t2 ? true : t2;
    let t3;
    if ($[19] !== validate) {
        t3 = Array.isArray(validate) ? compose(validate) : validate;
        $[19] = validate;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== defaultValue || $[22] !== rest || $[23] !== t3) {
        t4 = _object_spread_props(_object_spread({}, rest), {
            validate: t3,
            initialValue: defaultValue
        });
        $[21] = defaultValue;
        $[22] = rest;
        $[23] = t3;
        $[24] = t4;
    } else t4 = $[24];
    const { input, meta } = useField(name, t4);
    const { onChange: onInputChange } = input;
    let t5;
    if ($[25] !== onChange || $[26] !== onInputChange) {
        t5 = (formValue)=>{
            onInputChange(formValue);
            if (onChange) onChange(formValue);
        };
        $[25] = onChange;
        $[26] = onInputChange;
        $[27] = t5;
    } else t5 = $[27];
    const handleChangeForm = t5;
    let t6;
    if ($[28] !== debounceTimeout || $[29] !== handleChangeForm) {
        t6 = debounce(handleChangeForm, debounceTimeout);
        $[28] = debounceTimeout;
        $[29] = handleChangeForm;
        $[30] = t6;
    } else t6 = $[30];
    const handleChangeDebounce = t6;
    let t7;
    let t8;
    if ($[31] !== handleChangeDebounce) {
        t7 = ()=>()=>{
                handleChangeDebounce.flush();
            };
        t8 = [
            handleChangeDebounce
        ];
        $[31] = handleChangeDebounce;
        $[32] = t7;
        $[33] = t8;
    } else {
        t7 = $[32];
        t8 = $[33];
    }
    useEffect(t7, t8);
    let t10;
    let t9;
    if ($[34] !== autoSetDefault || $[35] !== defaultValue || $[36] !== input || $[37] !== options) {
        t9 = ()=>{
            if (autoSetDefault && !input.value) input.onChange(defaultValue || options[0].value);
        };
        t10 = [
            autoSetDefault,
            defaultValue,
            input,
            options
        ];
        $[34] = autoSetDefault;
        $[35] = defaultValue;
        $[36] = input;
        $[37] = options;
        $[38] = t10;
        $[39] = t9;
    } else {
        t10 = $[38];
        t9 = $[39];
    }
    useEffect(t9, t10);
    let t11;
    if ($[40] !== debounceTimeout || $[41] !== handleChangeDebounce || $[42] !== handleChangeForm) {
        t11 = (changedValue)=>{
            if (debounceTimeout) handleChangeDebounce(changedValue);
            else handleChangeForm(changedValue);
        };
        $[40] = debounceTimeout;
        $[41] = handleChangeDebounce;
        $[42] = handleChangeForm;
        $[43] = t11;
    } else t11 = $[43];
    const handleChange = t11;
    if (!options || !options.length) return null;
    const t12 = meta.touched && !!meta.error;
    const t13 = showError && meta.touched && meta.error;
    let t14;
    if ($[44] !== disabled || $[45] !== handleChange || $[46] !== input || $[47] !== label || $[48] !== labelIcon || $[49] !== labelPlacement || $[50] !== options || $[51] !== required || $[52] !== row || $[53] !== t12 || $[54] !== t13 || $[55] !== testId || $[56] !== tooltip || $[57] !== withoutMargins) {
        t14 = /*#__PURE__*/ jsx(RadioInput, _object_spread_props(_object_spread({}, input), {
            items: options,
            label: label,
            labelIcon: labelIcon,
            value: input.value,
            onChange: handleChange,
            required: required,
            disabled: disabled,
            tooltip: tooltip,
            row: row,
            withoutMargins: withoutMargins,
            labelPlacement: labelPlacement,
            testId: testId,
            error: t12,
            helperText: t13
        }));
        $[44] = disabled;
        $[45] = handleChange;
        $[46] = input;
        $[47] = label;
        $[48] = labelIcon;
        $[49] = labelPlacement;
        $[50] = options;
        $[51] = required;
        $[52] = row;
        $[53] = t12;
        $[54] = t13;
        $[55] = testId;
        $[56] = tooltip;
        $[57] = withoutMargins;
        $[58] = t14;
    } else t14 = $[58];
    return t14;
};
const form_RadioInput_RadioInput = RadioInput_RadioInput;
export default form_RadioInput_RadioInput;
